import api from "../config/Axios.config";

export const getCategories = async () => {
  const categories = await api.get('/categories');
  console.log(categories);
  return categories.data.data;
};

export const getCategoriesPosts = async (page, name) => {
  try {
    const categoryPosts = await api.get(`/posts/category/${name}?page=${page}`);
    console.log(categoryPosts);
    console.log(categoryPosts.data.data.data);
    if(categoryPosts.data.status === 1) {
        return {
          data: categoryPosts.data.data.data,
          last_page: categoryPosts.data.data.last_page,
        };
    }

    return {
      data: categoryPosts.data.data
    };
  } catch (error) {
    console.log("ERROR: ", error)
  }
};
